import { loadingChunkRetry } from '@sit/client-shared';
import { lazy, Suspense } from 'react';
import { TimesheetModals } from './components/TimesheetModals';
import { TimesheetsContainerLayout } from './TimesheetsContainerLayout';

const Timesheets = lazy(() => loadingChunkRetry(() => import('./Timesheets')));

const TimesheetsContainer = () => {
  return (
    <TimesheetsContainerLayout>
      <TimesheetModals />
      <Suspense fallback={null}>
        <Timesheets />
      </Suspense>
    </TimesheetsContainerLayout>
  );
};

export default TimesheetsContainer;
